import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import FormControl from "@mui/material/FormControl";
import { CircularProgress, TextField } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { showToast } from "../../../helpers/ToastifyHelper";
import MeclisKararlariAPI from "../../../apis/OB/Get/MeclisKararlariAPI";
import TahsilatBilgileriListeAPI from "../../../apis/OB/Get/TahsilatBilgileriListeAPI";
import { useNavigate } from "react-router";
import SessionStorageService from "../../../services/StorageService";
import TableComponent2 from "../../../components/OB/TableComponent2";
import TahsilatRaporAPI from "../../../apis/OB/Rapor/TahsilatRaporAPI";
import { openFileInNewTab } from "../../../helpers/openFileNewTab";
import { today } from "../../../helpers/TodayDate";
import OdemeBilgileriPopUp from "../../../components/OB/popups/OdemeBilgileriPopUp";
import TahsilatBilgileriGetApi from "../../../apis/OB/Get/TahsilatBilgileriGetApi";
import "./OdemeBilgileri.css";
import dayjs from "dayjs";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";

const OdemeBilgileri: React.FC = () => {
  //Input UseStateleri
  const [ilkTarih, setIlkTarih] = useState<any>(null);
  const [sonTarih, setSonTarih] = useState<any>(null);
  const [makbuzNo, setMakbuzNo] = useState<any>(null);
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [searchControl, setSearchControl] = useState<boolean>(true);
  const [requestControl, setRequestControl] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState<boolean>(false);

  const columns = [
    {
      header: "",
      field: "",
      className: "",
      beyan: 4,
      case: 1,
      classNameDiv: "gap-1 d-flex"
    },
    { header: "Detay", field: "kararIcerigiBase64", className: "text-center" },
    { header: "Ödeme Tarihi", field: "odemeTarihi", className: "text-center" },
    {
      header: "Havale Tarihi",
      field: "havaleTarihi",
      className: "text-center",
    },
    { header: "Ödeme Yeri", field: "vezneKodu", className: "text-center" },
    { header: "Makbuz No", field: "makbuzNo", className: "text-center" },
    {
      header: "Ana Tahsilat Toplamı",
      field: "anaTahsilatToplam",
      className: "text-center",
    },
    {
      header: "Gecikme ve Faiz Toplamı",
      field: "gecikmeFaizToplam",
      className: "text-center",
    },
    {
      header: "Makbuz Toplamı",
      field: "makbuzToplam",
      className: "text-center",
    },
  ];
  //Pop up
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const openPopup = () => {
    isPopupVisible == true ? setIsPopupVisible(false) : setIsPopupVisible(true);
  };
  //print Rapor
  const printRapor = (
    tahsilatTarihi: Date,
    vezneKodu: number,
    seriNo: string,
    makbuzNo: number
  ) => {
    TahsilatRaporAPI.geExportPdfListe(
      safelyParseNumber(user.sicilKodu) || 0,
      tahsilatTarihi,
      vezneKodu,
      seriNo,
      makbuzNo
    )
      .then((res) => {
        if (res.data !== null) {
          openFileInNewTab(
            res.data.reportUrlByteFormat,
            "-BORDRO-BİLGİLERİ - " + today + ".pdf"
          );
        } else {
          showToast("Pdf indirilirken bir sorun oluştu", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        showToast("Pdf indirilirken bir sorun oluştu", "error");
      });
  };
  const getTahsilatBilgileriGet = async (
    odemeTarihi: string,
    vezneKodu: number,
    seriNo: string,
    makbuzNo: number
  ) => {
    const response = await TahsilatBilgileriGetApi.getTahsilatBilgileriGet(
      safelyParseNumber(user.sicilKodu) || 0,
      odemeTarihi,
      vezneKodu,
      seriNo,
      makbuzNo
    );
    console.log(response.data);
    setTarifeGetData(response.data);
    response.data == null
      ? showToast("Kayıt bulunamadı", "warning")
      : openPopup();
  };

  //Kullanıcı Login control ve yönlendirme

  const navigate = useNavigate();
  let user = SessionStorageService.getUserInfo();
  const [userControlPopup, setUserControlPopup] = useState(false);
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {
    if (user == null) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, []);

  //TahsilatBilgileriListeAPI
  const fetchData = async () => {
    if (ilkTarih !== null && sonTarih !== null) {
      setisLoading(true);
      if (user == null) {
        showToast("Kullanıcı bulunamdı", "error");
        return;
      }

      if (ilkTarih > sonTarih) {
        showToast("İlk tarih son tarihten büyük olamaz", "error");
        return;
      }
      // edinmeTarihi: dayjs(values.edinmeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD")
      //Post işlemi normal get işleminde toString
      const response =
        await TahsilatBilgileriListeAPI.getTahsilatBilgileriListe(
          safelyParseNumber(user.sicilKodu) || 0,
          dayjs(ilkTarih).tz("Europe/Istanbul").format("YYYY-MM-DD"),
          dayjs(sonTarih).tz("Europe/Istanbul").format("YYYY-MM-DD"),
          makbuzNo
        );
      setIsSearched(true)
      if (response.data[0].sonuc == 1)
        response.data = []
      setData(response.data);
      setTimeout(() => {
        setisLoading(false);

      }, 100)
      setSearchControl(true);
      if (response.data.length < 1) showToast("Kayıt Bulunamadı!", "warning");
    } else {
      setSearchControl(false);
      showToast("ilk tarih ve son tarih alanları zorunludur", "error");
    }
  };
  const [data, setData] = useState<any[]>([]);
  const [tarifeGetData, setTarifeGetData] = useState<any[]>([]);

  //Temizleme fonksiyonu
  const handleTemizle = () => {
    setIlkTarih(null);
    setSonTarih(null);
    setMakbuzNo(null);
  };
  //Formik constantları
  const initialValues = {
    //boş kalacak ihtiyaca göre kullanılabilir
  };
  return isLoad ? (
    <>
      <div className="d-flex align-self-strech justify-content-center align-items-center">
        {" "}
        <CircularProgress />
      </div>
      {userControlPopup ? (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      ) : null}
    </>
  ) : (
    <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
      <div className="card-body p-0">
        <Formik initialValues={initialValues} onSubmit={() => { }}>
          <Form id="kayit-form" className="d-flex w-100 mb-4">
            <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
              <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <CustomDatePicker
                    label="İlk Tarih *"
                    slotProps={{
                      textField: {
                        size: "small",
                        color:
                          ilkTarih == null && searchControl == false
                            ? "error"
                            : "primary",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        border:
                          ilkTarih == null && searchControl == false
                            ? "1px solid red"
                            : "",
                      },
                      "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                        border:
                          ilkTarih == null && searchControl == false
                            ? "1px solid red"
                            : "",
                      },
                    }}
                    value={ilkTarih || null}
                    onChange={(newValue: any) => {
                      setIlkTarih(newValue || null);
                    }}
                  />
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <CustomDatePicker
                    label="Son Tarih *"
                    slotProps={{
                      textField: {
                        size: "small",
                        color:
                          sonTarih == null && searchControl == false
                            ? "error"
                            : "primary",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        border:
                          sonTarih == null && searchControl == false
                            ? "1px solid red"
                            : "",
                      },
                      "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                        border:
                          sonTarih == null && searchControl == false
                            ? "1px solid red"
                            : "",
                      },
                    }}
                    value={sonTarih || null}
                    onChange={(newValue: any) => {
                      setSonTarih(newValue || null);
                    }}
                  />
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <TextField
                    id=""
                    label="Karar No"
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                    }}
                    value={makbuzNo || ""}
                    onChange={(event) =>
                      event.target.value === ""
                        ? setMakbuzNo(null)
                        : event.target.value.match(/^[0-9]+$/)
                          ? setMakbuzNo(event.target.value)
                          : null
                    }
                  />
                </FormControl>
              </div>
              <div className="d-flex  flex-row ms-auto ">
                <SearchComponent
                  fetchData={fetchData}
                  onTemizle={handleTemizle}
                  setData={setData}
                />
              </div>
            </div>
          </Form>

        </Formik>
        {isLoading ?
          <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

            <CircularProgress />
          </div>
          : <TableComponent2
            columns={columns}
            data={data}
            recordsPerPage={10}
            printRapor={printRapor}
            getTahsilatBilgileriGet={getTahsilatBilgileriGet}
            isSearched={isSearched}
          ></TableComponent2>
        }
        {isPopupVisible ? (
          <OdemeBilgileriPopUp openPopup={openPopup} data={tarifeGetData} />
        ) : null}
      </div>
    </div >
  );
};
export default OdemeBilgileri;
